import { TMCTableModule } from '@sdbn/common';
import { CompleteUmbrueckungDialogComponent } from './component/complete-umbrueckung-dialog.component';
import {  ServiceResponseModule } from '@sdbn/common';
import { BeginUmbrueckungDialogComponent } from './component/begin-umbrueckung-dialog.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [BeginUmbrueckungDialogComponent, CompleteUmbrueckungDialogComponent],
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    TMCTableModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatTooltipModule,
    MatInputModule
  ]
})
export class TransportUmbrueckungModule { }
